import { TileType } from '../types';

interface TileProps {
  tile: TileType;
}

export default function Tile({ tile }: TileProps) {
  const { value, isNew, isMerged } = tile;
  
  // Generate tile background color and text color based on its value
  // Colors match original 2048 game
  const getTileStyles = (value: number) => {
    const styles: Record<number, { bg: string, text: string }> = {
      2: { bg: 'bg-[#eee4da]', text: 'text-[#776e65]' },
      4: { bg: 'bg-[#ede0c8]', text: 'text-[#776e65]' },
      8: { bg: 'bg-[#f2b179]', text: 'text-[#f9f6f2]' },
      16: { bg: 'bg-[#f59563]', text: 'text-[#f9f6f2]' },
      32: { bg: 'bg-[#f67c5f]', text: 'text-[#f9f6f2]' },
      64: { bg: 'bg-[#f65e3b]', text: 'text-[#f9f6f2]' },
      128: { bg: 'bg-[#edcf72]', text: 'text-[#f9f6f2]' },
      256: { bg: 'bg-[#edcc61]', text: 'text-[#f9f6f2]' },
      512: { bg: 'bg-[#edc850]', text: 'text-[#f9f6f2]' },
      1024: { bg: 'bg-[#edc53f]', text: 'text-[#f9f6f2]' },
      2048: { bg: 'bg-[#edc22e]', text: 'text-[#f9f6f2]' },
    };
    
    return styles[value] || { bg: 'bg-gray-800', text: 'text-white' };
  };
  
  const { bg, text } = getTileStyles(value);
  
  // Determine font size based on tile value length
  const getFontSize = (value: number) => {
    if (value < 100) return 'text-4xl';
    if (value < 1000) return 'text-3xl';
    return 'text-2xl';
  };
  
  const fontSize = getFontSize(value);
  
  // Add animation classes for new tiles and merged tiles
  const animationClass = isNew 
    ? 'animate-tile-appear'
    : isMerged 
      ? 'animate-tile-merge' 
      : '';
  
  return (
    <div 
      className={`
        ${bg} ${text} ${fontSize} ${animationClass}
        rounded-md flex items-center justify-center
        font-bold w-full h-full shadow-md
      `}
    >
      {value}
    </div>
  );
}